const apiUrl = process.env.REACT_APP_API_URL;

export const PutCazaIntentos = async (idCaza: string, userId: string, intentos: number, idConjunt?: number | null) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/caza/${idCaza}/alumnos`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ userId, intentos, idConjunt: idConjunt ?? null })
        });
        return response.ok;
    } catch (error) {
        console.log('Error updating Caza intentos:', error);
        return false;
    }
};
